/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerCreateMutationResponse } from "../../models/incidentAgentController/IncidentInvestigationControllerCreate";

function getIncidentInvestigationControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/incident-agent/investigations` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations}
 */
export async function incidentInvestigationControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerCreateMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentInvestigationControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}